export const DIVISOR_FOR_CURRENCY_VALUE = 1000000;
